/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mcp_Servers_Refresh_SuccessInputs */



/**
* | output |
* | --- |
* | "Refreshed: {count} tools discovered." |
*
* @param {Mcp_Servers_Refresh_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_refresh_success = /** @type {((inputs: Mcp_Servers_Refresh_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Refresh_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktualisiert: ${i?.count} Tools erkannt.`)
	return /** @type {LocalizedString} */ (`Refreshed: ${i?.count} tools discovered.`)
});